import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import { Badge } from "react-bootstrap";
import moment from "moment-timezone";

import AdminSidebar from "../layouts/AdminSidebar";
import { authCall } from "../../services";

function HotelPaymentListing() {
  const { current } = useSelector((state) => state.user);
  const [paymentList, setPaymentList] = useState([]);
  const [company, setCompany] = useState([]);
  const [companyStaff, setCompanyStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [accountId, setAccountId] = useState(current?.stripe_account_id);

  async function getCompany() {
    const resp = await authCall("getUserCompany", {
      userId: current?.id,
      companyType: current?.user_type,
    });
    if (resp?.type === "success") {
      setCompany(resp?.payload);
    } else {
      setCompany([]);
    }
  }

  async function getCompanyStaff(id) {
    const resp = await authCall("getCompanyStaff", {
      companyId: id,
      userType: current?.user_type,
    });
    if (resp?.type === "success") {
      const staff = resp?.payload?.map((s) => ({
        value: s.id,
        label: s.staffName,
      }));
      setCompanyStaff(staff);
    } else {
      setCompanyStaff([]);
    }
  }

  async function fetchData(id) {
    setLoading(true);
    const resp = await authCall("getStaffPayments", {
      staffId: id,
    });
    if (resp?.type === "success") {
      setPaymentList(resp?.payload);
      setLoading(false);
    } else {
      setPaymentList([]);
      setLoading(false);
      toast.error(resp?.errormessage);
    }
  }

  useEffect(() => {
    fetchData(41);
    getCompany();
  }, []);

  const handleChangeCompay = (selected) => {
    getCompanyStaff(selected?.value);
  };

  const handleChangeCompanyStaff = (selected) => {
    fetchData(selected?.value)
  };

  return (
    <>
      <div className="update-machine-page common-table-design py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-sm-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-sm-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">Itemized Payments:</div>
                <div className="details-wrapper py-lg-4">
                  {console.log(current)}
                  <div
                    className="main-heading2"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    {/* Daily Deals: */}
                    <Button
                      className="btn btn-custom btn-custom-sm fs-16"
                      // onClick={addDeal}
                    >
                      My Earning
                    </Button>
                  </div>
                  <Row className="align-items-center mb-4">
                    <Col xs={4}>
                      <span className="fs-sm">
                        Filter by {current?.user_type}:
                      </span>
                      <Select
                        className="text-body mt-1"
                        placeholder="Select"
                        // value={selectedOption}
                        onChange={handleChangeCompay}
                        options={company}
                      />
                    </Col>

                    {current?.user_type === "Admin" && (
                      <Col xs={4}>
                        <span className="fs-sm">Filter by Company:</span>
                        <Select
                          className="text-body mt-1"
                          placeholder="Select"
                          // value={companySelectedOption}
                          // onChange={handleChangeComapny}
                          options={[]}
                        />
                      </Col>
                    )}
                    <>
                      <Col xs={4}>
                        <span className="fs-sm">Filter by Staff:</span>
                        <Select
                          className="text-body mt-1"
                          placeholder="Select"
                          // value={categorySelectedOption}
                          onChange={handleChangeCompanyStaff}
                          options={companyStaff}
                        />
                      </Col>
                    </>
                  </Row>
                  <div className="table-responsive">
                    <table className="table table-borderless table-custom m-0">
                      <thead>
                        <tr>
                          <th scope="col">#:</th>
                          <th scope="col">Amount:</th>
                          <th scope="col">Payment Type:</th>
                          <th scope="col">User Name:</th>
                          <th scope="col">User Phone:</th>
                          <th scope="col">Status:</th>
                          <th scope="col">Date:</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!loading &&
                          (paymentList.length > 0 ? (
                            paymentList.map((el, index) => (
                              <tr key={index}>
                                <td scope="row">#{index + 1}</td>
                                <td>$ {el.amount.toFixed(2)}</td>
                                <td>{el.payment_type}</td>
                                <td>{el?.user_name}</td>
                                <td>{el?.user_phone}</td>
                                <td className="text-center1">
                                  <Badge
                                    bg="success"
                                    className="cursor-pointer"
                                  >
                                    Success
                                  </Badge>
                                </td>
                                <td>
                                  {moment(el?.created_at).format(
                                    "YYYY-MM-DD HH:mm:ss"
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={10} className="text-center">
                                No record found
                              </td>
                            </tr>
                          ))}
                        {loading && (
                          <tr>
                            <td colSpan={10} className="text-center">
                              Loading...
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HotelPaymentListing;
